import cookie from 'react-cookie';

import {getExpiredDateFromToday} from '../helpers/expiredDate.helper';
import {FOODIT_LOCALSTORAGE} from '../constants/constant';

export const isLocalStorageSupported = () => {
  const TEST_KEY = 'localstorage.test.key';
  try {
    localStorage.setItem(TEST_KEY, TEST_KEY);
    localStorage.removeItem(TEST_KEY); // make sure localStorage is working
    return true;
  } catch (e) {
    return false;
  }
};

export const persistValueToLocalStorage = (key, value) => {
  if (isLocalStorageSupported()) {
    localStorage.setItem(key, JSON.stringify(value));
  } else {
    cookie.save(key, JSON.stringify(value), {
      path: '/',
      expires: getExpiredDateFromToday(key === FOODIT_LOCALSTORAGE.CHECKOUT_DATA ? 365 : __CONFIG__.cookiesExpireDays)
    });
  }
};

export const removeValueFromLocalStorage = (key) => {
  if (isLocalStorageSupported()) {
    localStorage.removeItem(key);
  } else {
    cookie.remove(key);
  }
};

export const getValueFromLocalStorage = key => {
  if (__SERVER__) {
    return;
  }
  try {
    if (isLocalStorageSupported()) {
      return JSON.parse(localStorage.getItem(key));
    } else {
      return JSON.parse(cookie.load(key));
    }
  } catch (e) {
    removeValueFromLocalStorage(key);
  }
};



// WEBPACK FOOTER //
// ./helpers/localStorage.helper.js